import "core-js/modules/es.array.concat";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { rootContext, extractJson } from 'wfui-digital-core/es/lib';
import globals from '../globals/globals';
import get from '../network/get';
export default (function (language) {
  if (globals().embeddedStrings) {
    var strings = globals().embeddedStrings;
    delete window.mwfGlobals.embeddedStrings;
    return extractJson(strings);
  } else {
    var path = globals().stringsPath || '/strings';
    var url = "".concat(rootContext()).concat(path, "/").concat(language);
    return get({
      url: url,
      includeRootContext: false,
      cache: true
    });
  }
});